import assetPath from '/app/packages/lebenslauf/articles/src/assets/elternzeit-im-lebenslauf.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')